import { render, staticRenderFns } from "./ArquivoReprovado.vue?vue&type=template&id=6df7e257&scoped=true"
import script from "./ArquivoReprovado.vue?vue&type=script&lang=js"
export * from "./ArquivoReprovado.vue?vue&type=script&lang=js"
import style0 from "./ArquivoReprovado.vue?vue&type=style&index=0&id=6df7e257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df7e257",
  null
  
)

export default component.exports